<template>
  <div>
    <div class="batchOperation" v-if="batchOperBtn.length > 0">
      <ul>
        <li
          class="batchBtn"
          v-for="item in batchOperBtn"
          :key="item.title"
          @click="item.click()"
        >
          <a href="javascript:;">
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </a>
        </li>
        <li class="li_btn_self_Css" v-if="messageDescript">{{ messageDescript }}</li>
      </ul>
    </div>
    <div class="ots-table">
      <el-table
        ref="el_table"
        :data="tableData"
        @selection-change="handleSelectionChange"
        @current-change="handleCurrentChange"
        :highlight-current-row="tableOption.singleSelect"
        style="width: 100%"
        :empty-text="emptyText"
      >
        <el-table-column
          v-if="tableOption.multiple"
          type="selection"
          :selectable="tableOption.selectTable"
          width="55"
        >
        </el-table-column>

        <el-table-column v-if="tableOption.singleSelect" width="55">
          <template slot-scope="scope">
            <el-radio :label="scope.row" v-model="currentRow"></el-radio>
          </template>
        </el-table-column>

        <template v-for="(item, index) in tableHeader">
          <el-table-column
            :key="index"
            v-if="!item.type"
            v-bind="setAttribute(item, index)"
          >
            <template slot-scope="scope">
              <span class="table-text" v-html="getTableText(item, scope)">
              </span>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            v-else-if="item.type === 'Left_TableHeader'"
            v-bind="setAttribute_Left(item, index)"
            align="left"
          >
             <template slot-scope="scope">
              <p style="text-align: left">
                <span class="table-text" v-html="getTableText(item, scope)">
                </span>
              </p>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            v-else-if="item.type === 'switch'"
            v-bind="setAttribute(item, index)"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row[item.prop]"
                :active-value="1"
                :inactive-value="0"
                @change="item.switchChange(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            v-bind="setAttribute(item, index)"
            v-else-if="item.type === 'tag'"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.color" :color="scope.row.color"
                >{{ scope.row[item.prop] }}
              </el-tag>
              <el-tag v-if="scope.row.tagType" :type="scope.row.tagType"
                >{{ scope.row[item.prop] }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column
            :key="index"
            v-else-if="item.type === 'button'"
            v-bind="setAttribute(item, index)"
            :align="item.align || 'center'"
          >
            <template slot-scope="scope">
              <el-button
                :type="'text'"
                :size="item.size || 'mini'"
                :disabled="
                  item.disableFn ? item.disableFn(scope) : item.disabled
                "
                @click="item.click(scope.row)"
                v-html="getTableText(item, scope)"
              >
              </el-button>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            class="operate"
            v-else-if="item.type === 'buttons'"
            v-bind="setAttribute(item, index)"
            align="right"
            headerAlign="right"
            fixed="right"
          >
            <template slot-scope="scope">
              <div style="display: flex; justify-content: right;">
                <div v-for="(itemBtn, index) in item.btnList" >
                  <el-tooltip class="item" effect="light" placement="top-start" v-if="itemBtn.type == 'tooltip'">
                    <p slot="content" style="line-height: 18px;" v-html="itemBtn.data(scope)"></p>
                    <span style="color: #006AFF; cursor: pointer;">试题检测项</span>
                  </el-tooltip>
                  <el-button
                    v-else
                    :key="index"
                    :type="itemBtn.type || 'text'"
                    :size="itemBtn.size || 'mini'"
                    :disabled="itemBtn.disableFn ? itemBtn.disableFn(scope) : itemBtn.disabled"
                    v-html="getBtnText(itemBtn, scope)"
                    @click="itemBtn.click(scope.row, itemBtn,scope.$index)"
                    style="margin-left: 8px;"
                    >
                    <span>
                      {{ itemBtn.title }}
                    </span>
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            class="operate"
            v-else-if="item.type === 'buttons_set'"
            v-bind="setAttribute(item, index)"
            fixed="right"
          >
            <template slot="header">
              <el-tooltip class="item" effect="dark" :content="item.tableSettings.content" placement="top" v-show="item.disabled">
                <i class="icon" :class="item.tableSettings.icon" @click="item.tableSettings.click" ></i>
              </el-tooltip>
              <i class="icon" :class="item.tableSettings.icon" style="color: #CCC" v-show="!item.disabled"></i>
              <span>&nbsp;&nbsp;操作</span>
            </template>

            <template slot-scope="scope">
              <el-button
                v-for="(itemBtn, indexBtn) in item.btnList"
                :key="indexBtn"
                :type="itemBtn.type || 'text'"
                :size="itemBtn.size || 'mini'"
                :disabled="itemBtn.formatter ? itemBtn.formatter(scope) : itemBtn.disabled"
                @click="itemBtn.click(scope.row, itemBtn)"
              >
                {{ typeof itemBtn.title === "function" ? itemBtn.title(scope) : itemBtn.title }}
              </el-button>
            </template>
          </el-table-column>


          <!-- 场次设置 => 场次查看 按钮特例: 单教室普通显示, 多教室鼠标悬浮展示列表 -->
          <el-table-column
            :key="index"
            v-bind="setAttribute(item, index)"
            v-else-if="item.type === 'isButton'"
          >
            <template slot-scope="scope">
              <!-- <span v-if="!(scope.row.classNames.split(',').length > 1)" :style="{ 'color': scope.row.classNames.split(',').length > 1 ? '#006AFF': '' }">
                {{ scope.row.classNames.split(",").length > 1 ? '查看详情' : scope.row[item.prop] }}
              </span> -->
              <!-- <el-tooltip 
                class="item" 
                effect="dark" 
                placement="top-start" 
                v-else-if="isSectionLook && (item.prop == 'classNames')"
              > -->
                <!-- <p slot="content" v-html="MouseHover_Show(item, scope)" style="line-height: 18px;"></p> -->
              <span 
                style="cursor: pointer;" 
                :style="{ 'color': scope.row.classNames.split(',').length > 1 ? '#006AFF': '' }" 
                v-if="isSectionLook && (item.prop == 'classNames')" 
                @click="item.click(scope.row)"
              >
                {{ scope.row.classNames.split(",").length > 1 ? '查看详情' : scope.row[item.prop] }}
              </span>
              <!-- </el-tooltip> -->
              <span v-else class="table-text" v-html="getTableText(item, scope)" @click="getTableText(item, scope)"></span>
            </template>
          </el-table-column>
          <!-- 新增一个文本框 -->
          <el-table-column
            :key="index"
            v-else-if="item.type === 'input'"
            v-bind="setAttribute(item, index)">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row[item.prop]"
                :placeholder="item.placeholder"
                :maxlength="item.maxlength"
              ></el-input>
            </template>
          </el-table-column>
          <!-- 新增一按钮   -->
          <el-table-column
            :key="index"
            v-else-if="item.type === 'spanlist'"
            v-bind="setAttribute(item, index)">
            <template slot-scope="scope">
              <span class="spanPos" v-for="(itemBtn, index) in item.btnList"  :key="index">
                <!-- PDF -->
                <el-button
                  v-if="itemBtn.id == '1'"
                  :type="itemBtn.type || 'text'"
                   class="spanCurBtn"
                  :class="{'grayBtn': scope.row.isPdfSelect }"
                  @click="itemBtn.click(scope.row, itemBtn)"
                  >{{ itemBtn.title }}
                </el-button>
                <!-- 图片 -->
                <el-button
                  v-if="itemBtn.id == '2'"
                  :type="itemBtn.type || 'text'"
                  class="spanCurBtn"
                  :class="{'grayBtn': scope.row.isImgSelect }"
                  @click="itemBtn.click(scope.row, itemBtn)"
                  >{{ itemBtn.title}}
                </el-button>
                <!-- Word -->
                <el-button
                  v-if="itemBtn.id == '3'"
                  :type="itemBtn.type || 'text'"
                  class="spanCurBtn"
                  :class="{'grayBtn': scope.row.isWordSelect }"
                  @click="itemBtn.click(scope.row, itemBtn)"
                  >{{ itemBtn.title}}
                </el-button>
            </span>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            v-else-if="item.type === 'textAndButton'"
            v-bind="setAttribute(item, index)"
            :align="item.align || 'center'"
          >
            <template slot-scope="scope">
              <span class="table-text" v-html="getTableText(item, scope)"></span>&nbsp;
              <el-button
                :type="'text'"
                :size="item.size || 'mini'"
                :disabled="item.disableFn ? item.disableFn(scope) : item.disabled"
                @click="item.click(scope.row)"
                v-html="item.btnText(scope.row)"
              >
              </el-button>
            </template>
          </el-table-column>

          <el-table-column
            :key="index"
            v-else-if="item.type === 'textTooltip'"
            v-bind="setAttribute(item, index)"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                placement="right-start"
              >
                <p slot="content" v-html="item.data(scope)"></p>
                <el-link
                    type="primary"
                    :underline="false"
                    class="table-text"
                    v-html="getTableText(item, scope)"
                    @click="getTableText(item, scope)"
                ></el-link>
              </el-tooltip>
            </template>
          </el-table-column>

        </template>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: "OtsTable",
  props: {
    messageDescript: {
      type: String,
      default: () => ""
    },
    tableHeader: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableOption: {
      type: Object,
      default: () => ({}),
    },
    batchOperBtn: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: '暂无数据',
    },
  },
  data() {
    return {
      currentRow: null,
    };
  },
  computed: {
    isSectionLook() {
      return this.$route.name == "sectionLook"
    }
  },
  mounted() {
    // 学生端,缴费默认选中
    this.isPayFee();
  },
  methods: {
    /**
     * @param { 鼠标悬浮提示: 针对场次设置，场次查看，教室鼠标悬浮特例功能 }
    **/
    MouseHover_Show(item, scope){
      let data = scope.row.placeClassList
      let DiffDom = []
      data.map((e,i)=>{
        let className = e.className.split(',')
        let classItem = []
        className.map(item=>{
          let class_item = `<p style="line-height: 24px;">${item}</p>`
          classItem.push(class_item)
        })
        let Item = `
          <div>
            <h2 style="margin-bottom: 8px">${e.placeName}</h2>
            ${classItem.join('')}
            <p style="margin-bottom: 16px; display: ${i+1 < data.length ? 'block': 'none'}"></p>
          </div>
        `
        DiffDom.push(Item)
      })
      return DiffDom.join('')
    },

    /**************************************
     * @isPayFee 学生端缴费页面,表格默认选中
     **************************************/
    isPayFee() {
      if (this.$route.name == "payFee") {
        // 1. 页面渲染后
        this.$nextTick(() => {
          this.tableData.map((e) => {
            // 2. 判断是否是未缴费
            if (e.isPay == "未缴费") {
              this.$refs.el_table.toggleRowSelection(e, true);
            } else {
              return false;
            }
          });
        });
      } else {
        return false;
      }
    },
    setAttribute_Left(item,index) {
      let maxIndex = this.tableHeader.length - 1; //1.获取数组最后一个数据的数组下标
      let headerAlign = "";
      if (index === 0) {
        headerAlign = "left"; //2.第一个数据 靠左
      } else if (index === maxIndex) {
        headerAlign = "left"; //3.最后一个数据 靠右
      } else {
        headerAlign = item.headerAlign || "center"; //4.其他部分 居中
      }
      return {
        // headerAlign: index === 0 ? "left" : item.headerAlign || "center",
        headerAlign,
        prop: item.prop,
        fixed: item.fixed,
        label: item.title,
        width: item.width || "auto",
        align: index === 0 ? "left" : item.align || "center",
      };
    },


    setAttribute(item, index) {
      let maxIndex = this.tableHeader.length - 1; //1.获取数组最后一个数据的数组下标
      let headerAlign = "";
      if (index === 0) {
        headerAlign = "left"; //2.第一个数据 靠左
      } else if (index === maxIndex) {
        headerAlign = "right"; //3.最后一个数据 靠右
      } else {
        headerAlign = item.headerAlign || "center"; //4.其他部分 居中
      }
      return {
        // headerAlign: index === 0 ? "left" : item.headerAlign || "center",
        headerAlign,
        prop: item.prop,
        fixed: item.fixed,
        label: item.title,
        width: item.width || "auto",
        align: index === 0 ? "left" : item.align || "center",
      };
    },
    getTableText(item, scope) {
      let text = item.formatter ? item.formatter(scope) : scope.row[item.prop];
      return text || text == "0" ? text : "-";
    },
    getBtnText(item, scope) {
      let text = item.formatter ? item.formatter(scope) : scope.row[item.prop];
      return text || text == "0" ? text : item.title;
    },
    handleSelectionChange(tableCol) {
      this.$emit("handleSelectionChange", tableCol);
    },
    handleCurrentChange(tableCol) {
      this.currentRow = tableCol;
      this.$emit("handleCurrentChange", tableCol);
    },
  },
};
</script>

<style lang="less" scoped>
.ots-table .el-tag--success {
  background-color: #f1fff7;
  border-color: rgba(29, 191, 96, 0.35);
  color: #1dbf60;
}
.ots-table .el-tag--info {
  background-color: #f4f5f8;
  border-color: #dadde6;
  color: #9299a6;
}
.ots-table /deep/.el-button + .el-button {
  margin-left: 16px;
}
.ots-table /deep/ .el-radio__label {
  display: none;
}
/deep/ .el-table__row .el-button--mini {
  font-size: 13px !important;
  min-width: auto !important;
  padding: 0 !important;
}
.batchOperation {
  margin-bottom: 16px;
  ul {
    display: flex;
    li {
      a {
        border-radius: 20px;
        border: 1px solid #e1e6ed;
        padding: 8px 20px;
        display: block;
        margin-right: 24px;
        font-size: 14px;
        color: #006aff;
        i {
          margin-right: 4px;
        }
      }
    }
  }
}
/deep/ .el-table th > .cell {
  padding-left: 14px;
  padding-right: 14px;
}

/* 标题偏右 */
.el-table th > .cell:last-of-type(2) {
  text-align: right !important;
}
/* 内容偏右 */
/deep/ .el-table__body .el-table__row td:last-child .cell {
  text-align: right;
}
// 覆盖button样式
.spanCurBtn{
  padding: 0 !important;
  height: 32px !important;
  line-height: 32px !important;
  padding-left: 26px !important;
  padding-right: 26px !important;
  border-radius: 4px !important;
  background: #ebf5ff !important;
  border: 1px solid #006aff !important;
  color: #006aff !important;
}
.grayBtn{
  color: #45494d !important;
  background: #f4f5f8 !important;
  border: 1px solid #dadde6 !important;
}
.spanPos{
  margin-right: 8px;
}
.spanPos:last-child{
  margin-right: 0;
}
.li_btn_self_Css{
  font-size: 15px;
  color: #FE5859;
  padding-top: 10px;
  font-weight:600;
}
</style>
